import React, {useContext, useEffect, useRef, useState} from 'react';
import UserContext from '../../common/UserContext';

//Components
import Alert from '../../common/Alert';
import {DateCell, NoWrapCell} from "../../common/Grid";

// kendo react
import {Dialog, DialogActionsBar} from '@progress/kendo-react-dialogs';
import {Button} from '@progress/kendo-react-buttons';
import {Grid, GridColumn} from "@progress/kendo-react-grid";

// multilingual
import {useLocalization} from '@progress/kendo-react-intl';
import {
    assignedKey,
    cancelKey,
    deleteAllKey,
    confirmDeletionKey,
    deleteUnassignedKey,
    descriptionKey, contactUsHeaderKey,
    genericErrorTitleKey,
    licenseTypeKey,
    mainMessages,
    productNumberKey,
    qtyKey,
    statusKey,
    unassignedKey,
    startDateKey,
    endDateKey, totalKey
} from "../../../assets/text/MultilingualText";
import {InfoIcon} from "../../common/icons";
import KSMPopover from "../../common/Popovers";
import {AssignedProductContext, GeneralContext} from "../FSARequestLicenseContext";
import {TotalCell} from "./TotalCell";


export const DeleteModal = (props) => {
    const {
        setShowModal,
        item,
        deleteProduct,
        showGenericError,
        setShowGenericError,
    } = props;

    const {
        siteLanguageDefault
    } = useContext(UserContext);

    const{
        uniqueID,
        parentUniqueID,
        productNumKey,
        licenseStartDateKey,
        licenseEndDateKey
    } = useContext(GeneralContext)

    const {
        assignedProducts
    } = useContext(AssignedProductContext)

    const localization = useLocalization();

    const assigned = item.saved_assigned_quantity
    const unAssigned = item.saved_selected_quantity - item.saved_assigned_quantity

    const closeModal = (props) => {
        setShowGenericError(false);
        setShowModal(false);
    }

    const StatusCell = (props) => {
        let products = []
        assignedProducts.forEach((host) => {
            host.products.forEach((product) => {
                if(item[uniqueID] === product[parentUniqueID]) {
                    products.push({
                        panel_bar_title: host.panel_bar_title,
                        assign_quantity: product.assign_quantity,
                    })
                }
            })
        })

        const popoverAnchor = useRef(null);
        const [popoverShow, setPopoverShow] = useState(false)

        //Show popover if there is an error on mouse over
        const onMouseOver = (ev) => {
            setPopoverShow(true);
        };

        //Remove popover on mouse leave
        const onMouseOut = (ev) => {
            let isChildEl = ev.currentTarget.contains(ev.relatedTarget);
            if (!isChildEl) setPopoverShow(false);
        };

        return (
            <td>
                <span style={{
                    whiteSpace: 'nowrap'
                }}>
                    {unAssigned} {localization.toLanguageString(unassignedKey, mainMessages[siteLanguageDefault][unassignedKey])}

                    {assigned > 0 &&
                        (
                            <div>
                                {assigned} {localization.toLanguageString(assignedKey, mainMessages[siteLanguageDefault][assignedKey])}
                                <span
                                    onMouseOver={onMouseOver}
                                    onMouseOut={onMouseOut}
                                    ref={popoverAnchor}
                                    style={{float: 'right'}}
                                >
                                    <InfoIcon size={'medium'}/>
                                </span>
                                <br/>

                                <KSMPopover
                                    show={popoverShow}
                                    anchor={popoverAnchor.current}
                                    position={'left'}
                                    animate={false}
                                    message={
                                        <div>
                                            {
                                                products.map((product, index) => {
                                                    return (
                                                        <div key={index}>
                                                            {product.panel_bar_title}: {product.assign_quantity} {localization.toLanguageString(assignedKey, mainMessages[siteLanguageDefault][assignedKey])}
                                                            <br/>
                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>
                                    }
                                />
                            </div>
                        )
                    }
                </span>
            </td>
        )
    }

    return (
        <Dialog
            className={"ksm-dialog"}
            title={<h2 style={{
                fontWeight: "normal",
                margin: 0,
                color: 'var(--color-text-primary)'
            }}>
                {localization.toLanguageString(confirmDeletionKey, mainMessages[siteLanguageDefault][confirmDeletionKey])}
            </h2>}
            onClose={closeModal}
            width={"80.125rem"}
            height={"45vh"}
        >
            <div style={{}}>
                <Grid
                    className={'fsa-modal-grid'}
                    scrollable={'none'}
                    data={[item]}
                    sortable={false}
                >
                    <GridColumn
                        field={productNumKey}
                        title={localization.toLanguageString(productNumberKey, mainMessages[siteLanguageDefault][productNumberKey])}
                        cell={NoWrapCell}
                    />
                    <GridColumn
                        field="description"
                        title={localization.toLanguageString(descriptionKey, mainMessages[siteLanguageDefault][descriptionKey])}
                    />
                    <GridColumn
                        field="saved_selected_quantity"
                        title={localization.toLanguageString(qtyKey, mainMessages[siteLanguageDefault][qtyKey])}
                    />
                    <GridColumn
                        field="selected_license_type_text"
                        title={localization.toLanguageString(licenseTypeKey, mainMessages[siteLanguageDefault][licenseTypeKey])}
                    />
                    <GridColumn
                        field={licenseStartDateKey}
                        title={localization.toLanguageString(startDateKey, mainMessages[siteLanguageDefault][startDateKey])}
                        cell={DateCell}
                    />
                    <GridColumn
                        field={licenseEndDateKey}
                        title={localization.toLanguageString(endDateKey, mainMessages[siteLanguageDefault][endDateKey])}
                        cell={DateCell}
                    />
                    <GridColumn
                        field="total_cost"
                        title={localization.toLanguageString(totalKey, mainMessages[siteLanguageDefault][totalKey])}
                        cell={TotalCell}
                        sortable={false}
                    />
                    <GridColumn
                        field={'status_display'}
                        title={localization.toLanguageString(statusKey, mainMessages[siteLanguageDefault][statusKey])}
                        cell={StatusCell}
                    />
                </Grid>

                {showGenericError && (
                    <div style={{
                        marginTop: '0.938rem'
                    }}>
                        <Alert
                            type={'error'}
                            showHandler={()=>{setShowGenericError(false)}}
                            title={localization.toLanguageString(genericErrorTitleKey, mainMessages[siteLanguageDefault][genericErrorTitleKey])}
                            message={localization.toLanguageString(contactUsHeaderKey, mainMessages[siteLanguageDefault][contactUsHeaderKey])}
                        />
                    </div>
                )}
            </div>
            <DialogActionsBar layout="center">
                <Button
                    themeColor={"primary"}
                    size={"large"}
                    fillMode={"outline"}
                    rounded={"small"}
                    type={"button"}
                    onClick={() => {
                        setShowModal(false)
                    }}
                >
                    {localization.toLanguageString(cancelKey, mainMessages[siteLanguageDefault][cancelKey])}
                </Button>

                {unAssigned > 0 && assigned > 0 && (
                    <Button
                        themeColor={"primary"}
                        size={"large"}
                        fillMode={"solid"}
                        rounded={"small"}
                        type={"button"}
                        onClick={() => {
                            deleteProduct(item, true)
                        }}
                    >
                        {localization.toLanguageString(deleteUnassignedKey, mainMessages[siteLanguageDefault][deleteUnassignedKey])}
                    </Button>
                )}

                <Button
                    themeColor={"primary"}
                    size={"large"}
                    fillMode={"solid"}
                    rounded={"small"}
                    type={"button"}
                    onClick={() => {
                        deleteProduct(item, false)
                    }}
                >
                    {localization.toLanguageString(deleteAllKey, mainMessages[siteLanguageDefault][deleteAllKey])}
                </Button>
            </DialogActionsBar>
        </Dialog>
    )
}